export default __webpack_public_path__ + "static/button_yellow_down-6115848e1b24d027648055e6437fb19a.png";